// You can write more code here

/* START OF COMPILED CODE */

import BaseButton from "./BaseButton";
import UIButton from "../../components/core/UIButton";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class BtnPlayLevel extends BaseButton {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 60, y ?? 60);

    this.scaleX = 0.7;
    this.scaleY = 0.7;

    // btnPlay
    const btnPlay = scene.add.image(0, 0, "common", "btn-level-select.png");
    this.add(btnPlay);

    // icon
    const icon = scene.add.image(5, -3, "common", "icon-play-level.png");
    this.add(icon);

    // this (components)
    const thisUIButton = new UIButton(this);
    thisUIButton.pulseDelay = 1;
    thisUIButton.pulseScaleEnd = 0.8;
    thisUIButton.pulseSpeed = 1000;

    /* START-USER-CTR-CODE */
    this.setIdlePulse();
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  public pausePulse() {
    this.UIButton.pausePulse();
  }

  public resumePulse() {
    this.UIButton.resumePulse();
  }

  private setIdlePulse() {
    this.UIButton.setCustomPulseTween({
      targets: [this],
      scale: { from: 1, to: 1.05 },
      duration: 300,
      ease: Phaser.Math.Easing.Quadratic.InOut,
      loop: 2,
      yoyo: true,
      paused: true
    });
  }

  public setRepeatIdlePulse() {
    this.UIButton.setCustomPulseTween({
      targets: [this],
      scale: { from: 1, to: 1.05 },
      duration: 300,
      ease: Phaser.Math.Easing.Quadratic.InOut,
      loop: -1,
      yoyo: true,
      paused: true
    });
  }

  

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
